import {AfterViewInit, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {BroadcasterService} from "./core/broadcaster.service";
import {NotificationService} from "@progress/kendo-angular-notification";
import {Router} from "@angular/router";
import {SessionService} from "./core/services/session.service";

import {UserModel} from "./shared/models/user.model";
import {VERSION} from "../version";
import {showNotification} from "./shared/utilities/notificaton.util";
import {LoaderService} from "./core/services/loader.service";
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, AfterViewInit {
  public title = 'smart-de-webapp';
  public user: any;
  public version = VERSION;
  constructor(private broadcaster: BroadcasterService, private cdRef: ChangeDetectorRef, private notificationService: NotificationService,
              private router: Router, private sessionService: SessionService, protected loader: LoaderService) {
  }
  ngOnInit(): void {
    this.user = undefined;
    this.broadcaster.on('login').subscribe((data: any) => {
      // this.idle.watch();
      this.user = data[0];
      this.cdRef.detectChanges();
    });
    this.broadcaster.on('auth').subscribe(data => {
      this.user = data;
      // this.idle.interrupt();
      // if (!this.idle.isIdling()) {
      //   this.idle.watch();
      // }
    });
    this.broadcaster.on('logout').subscribe(data => {
      this.user = undefined;
    });
  }
  ngAfterViewInit(): void {
    this.sessionService.authUser().subscribe({
      next: (usr ) => {
        this.user = usr;
        this.cdRef.detectChanges();
        this.reset();
      },
      error: (err) => {
        this.router.navigate(['/']);
      }
    })
    this.cdRef.detectChanges();
  }
  public logout(): void {
    this.sessionService.logout().subscribe(r => {});
    this.router.navigate(['/']);
    showNotification('You have been logged out', 'info', this.notificationService);
  }
  public reset(): void {
    // this.idle.watch();
    // this.idleState = 'Started.';
    // this.timedOut = false;
  }
  public toggleDrawer() {
    this.broadcaster.broadcast('toggle');
  }
  public home(): void {
    this.router.navigate(['/smart/formsList']);
  }

}
